module.exports = __webpack_public_path__ + "NotoSans-Bold.ttf?8e668f557973211464c049791becd40d";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/NotoSans-Bold.ttf
// module id = 1256
// module chunks = 6